import { render, staticRenderFns } from "./storagemanage.vue?vue&type=template&id=7b12cb4c&scoped=true&"
import script from "./storagemanage.vue?vue&type=script&lang=js&"
export * from "./storagemanage.vue?vue&type=script&lang=js&"
import style0 from "./storagemanage.vue?vue&type=style&index=0&id=7b12cb4c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b12cb4c",
  null
  
)

export default component.exports